import errorMessage from '@/common/functions/message';
import {
  showLoading,
  hideLoading,
} from '@/common/functions/loading';
import { authKeycloak } from './authKeycloak';

const warnPropRewrite = (msg) => {
  if (process && process.env && process.env.NODE_ENV && process.env.NODE_ENV === 'development') {
    console.warn(`[interceptors.js - Response REWRITE] ${msg}`); // eslint-disable-line
  }
};

export default (Vue) => {
  Vue.http.interceptors.unshift((request, next) => {
    if (request.method === 'GET' && /\/thumbnail\/download(\?|$)/.test(request.url)) {
      request.headers.set('Accept', 'application/json');
      request.headers.set('Content-Type', 'application/json');
      request.params = request.params || {};
      if (!request.url.includes('file=') && this && this.file && this.file.name) {
        request.params.file = encodeURIComponent(this.file.name);
      }
    }
    next((response) => response);
  });
  Vue.http.interceptors.push((request, next) => {
    showLoading();
    next((response) => {
      try {
        return response;
      } finally {
        hideLoading();
      }
    });
  });
  Vue.http.interceptors.push((request, next) => {
    let controlador = sessionStorage.getItem('controladorTrade');

    if (controlador) {
      controlador = JSON.parse(controlador);
      if (controlador.idFuncionarioTitular) {
        request.headers.set('idFuncionario', controlador.idFuncionarioTitular.toString());
      }
      if (controlador.idDivisaoTitular) {
        request.headers.set('idDivisao', controlador.idDivisaoTitular.toString());
      }
    }
    next((response) => response);
  });
  Vue.http.interceptors.push((request, next) => {
    const tenantId = sessionStorage.getItem('xTenantId') ?? localStorage.getItem('xTenantId');
    if (tenantId && tenantId !== 'null' && tenantId !== 'undefined') {
      request.headers.set('x-tenant-id', tenantId);
    }
    next((response) => response);
  });
  Vue.http.interceptors.push((request, next) => {
    next((response) => {
      if (response.status >= 400) {
        const msg = errorMessage(response.body || response.data, Vue.config.lang);
        response.data = { error: msg };
        response.body = { error: msg };
        warnPropRewrite('Alterando a resposta quando existe erro. Mensagem vai sumir em producao');
      }
      return response;
    });
  });
  Vue.http.interceptors.push((request, next) => {
    let retried = request.headers.get('x-auth-retried') === '1';

    next(async (response) => {
      if (response && response.status === 401 && !retried) {
        retried = true;
        request.headers.set('x-auth-retried', '1');
        try {
          await authKeycloak.coalescedUpdate(request);

          const fresh = sessionStorage.getItem('token');
          if (fresh) {
            request.headers.set('Authorization', `Bearer ${fresh}`);
            request.headers.set('Accept', 'application/json');
            request.headers.set('Content-type', 'application/json');
            if (Vue.http && Vue.http.headers && Vue.http.headers.common) {
              Vue.http.headers.common.Authorization = `Bearer ${fresh}`;
            }
          }
          const retryResp = await Vue.http(request);
          return retryResp;
        } catch (e) {
          authKeycloak.notifySessionExpired();
          return response;
        }
      }

      return response;
    });
  });
};
